import { useState, useEffect } from "react";
import { brandTourManager } from "@/utils/brandTourManager";

export const useBrandGrandTour = () => {
  const [shouldShowTour, setShouldShowTour] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);

  useEffect(() => {
    // Check if grand tour should be shown
    const showTour = brandTourManager.shouldShowGrandTour();
    setShouldShowTour(showTour);

    // Get days remaining
    const remaining = brandTourManager.getDaysRemaining();
    setDaysRemaining(remaining);
  }, []);

  const hideTour = () => {
    brandTourManager.hideGrandTour();
    setShouldShowTour(false);
  };

  const resetTour = () => {
    brandTourManager.resetTourData();
    setShouldShowTour(false);
    setDaysRemaining(0);
  };

  return {
    shouldShowTour,
    daysRemaining,
    hideTour,
    resetTour,
  };
};
